import polyglotI18nProvider from "ra-i18n-polyglot";
import ptBrMessages from "ra-language-pt-br";
import * as domainMessages from "react-admin-import-csv/lib/i18n";

const messages: Record<string, any> = {
  "pt-br": {
    ...ptBrMessages,
    ...domainMessages.ptBR,
    ra: {
      ...ptBrMessages.ra,
      auth: {
        ...ptBrMessages.ra?.auth,
        username: "Usuário / E-mail / CPF / CNPJ",
      },
    },
  },
};

export const i18nProvider = polyglotI18nProvider(
  (locale) => messages[locale],
  "pt-br"
);
